export default __webpack_public_path__ + "static/media/cb0d9a4cd1da3940.e6ea8a8d152236d45fe0f06241482f27.svg";